import React from "react";
import { Calendar, Newspaper, UserCheck } from "lucide-react";
import { FaGraduationCap } from "react-icons/fa";
import "./TopNav.css";

function TopNav() {
  const [langOpen, setLangOpen] = React.useState(false);

  React.useEffect(() => {
  const removeBanner = setInterval(() => {
    const banner = document.querySelector(".goog-te-banner-frame");
    if (banner) {
      banner.style.display = "none";
    }
  }, 500);

  return () => clearInterval(removeBanner);
}, []);

  // Fecha o dropdown ao clicar fora
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".topnav__dropdown")) {
        setLangOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="topnav" role="navigation" aria-label="Barra superior">
      <div className="topnav__container">
        
        {/* Links Desktop */}
        <div className="topnav__left topnav__desktop-only">
          
          {/* Idioma Dropdown */}

          <a href="/comunicacao/eventos" className="topnav__link">
            <Calendar size={16} /> Eventos
          </a>
          <a href="/comunicacao/noticias" className="topnav__link">
            <Newspaper size={16} /> Notícias
          </a>
          <a href="/portal-do-estudante/cursos-online" className="topnav__link">
            <UserCheck size={16} /> Cursos Online
          </a>
        </div>

        {/* Links Mobile */}
        <div className="topnav__right topnav__mobile-only">
          <a
            href="https://portalonline.icsgisabelinha.com/"
            className="topnav__link"
          >
            <UserCheck size={16} />
            <span>Portal Online</span>
          </a>
          <a
            href="https://portalonline.icsgisabelinha.com/Publico/Candidaturas/Candidatura"
            className="topnav__link"
          >
            <FaGraduationCap size={16} />
            <span>Candidaturas Online</span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default TopNav;
